import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useEffect } from "react";
import HomePage from "./pages/Home";
import LogIn from "./pages/LogIn";
import CartPage from "./pages/CartPage";
import PaymentPage from "./pages/PaymentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentFailedPage from "./pages/PaymentFailedPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";
import RefundAndCancellation from "./pages/RefundAndCancellation";
import AboutUs from "./pages/AboutUs";
import { OfferContextProvider } from "./context/OfferContext";
import { LocationContextProvider } from "./context/LocationContext";
import { ErrorContextProvider } from "./context/ErrorContext";
import ProtectedRoute from "./ProtectedRoute";
import ServerNotReachablePage from "./pages/ServerNotReachablePage";
import PageNotFound from "./pages/PageNotFound";
import OrderHistory from "./pages/OrderHistory";
import OrderDetails from "./pages/OrderDetails";
import ErrorLogs from "./pages/ErrorLogs";
import ErrorBoundary from "./component/ErrorBoundary/ErrorBoundary";
import CookieConsent from "./component/CookieConsent/CookieConsent";
import { initializeErrorHandlers } from "./utils/logger";

const theme = createTheme({
    palette: {
        primary: {
            main: "#000000", // Set the primary color
        },
        secondary: {
            main: "#ff0000", // Set the secondary color
        },
    },
});

function App() {
    // Initialize global error handlers for logging
    useEffect(() => {
        initializeErrorHandlers();
    }, []);

    return (
        <ErrorBoundary componentName="App">
        <div>
            <CookieConsent />
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
            <ErrorContextProvider>
                <OfferContextProvider>
                    <LocationContextProvider>
                        <ThemeProvider theme={theme}>
                            <BrowserRouter>
                                <Routes>
                                    <Route
                                        path="/"
                                        element={<LogIn />}
                                    />
                                    <Route
                                        path="/:id"
                                        element={<LogIn />
                                        }
                                    />
                                    <Route
                                        path="/catalogue"
                                        element={<HomePage />}
                                    />
                                    <Route
                                        path="/cart"
                                        element={<CartPage />}
                                    />
                                    <Route
                                        path="/order-history"
                                        element={<ProtectedRoute element={<OrderHistory />} />}
                                    />
                                    <Route
                                        path="/order-history/:orderid"
                                        element={<ProtectedRoute element={<OrderDetails />} />}
                                    />
                                    <Route
                                        path="/payment"
                                        element={<ProtectedRoute element={<PaymentPage />} />}
                                    />
                                    <Route
                                        path="/payment-success"
                                        element={
                                            <ProtectedRoute element={<PaymentSuccessPage />} />
                                        }
                                    />
                                    <Route
                                        path="/payment-failed"
                                        element={<ProtectedRoute element={<PaymentFailedPage />} />}
                                    />
                                    <Route
                                        path="/server-not-reachable"
                                        element={
                                            <ServerNotReachablePage />
                                        }
                                    />
                                    <Route path="/privacy-policy/:id?" element={<PrivacyPolicy />} />
                                    <Route
                                        path="/terms-and-condition/:id?"
                                        element={<TermsAndCondition />}
                                    />
                                    <Route
                                        path="/refund-and-cancellation/:id?"
                                        element={<RefundAndCancellation />}
                                    />
                                    <Route
                                        path="/about-us/:id?"
                                        element={<AboutUs />}
                                    />
                                    <Route
                                        path="/dev/error-logs"
                                        element={<ErrorLogs />}
                                    />
                                    <Route path="/*" element={<PageNotFound />} />
                                </Routes>
                            </BrowserRouter>
                        </ThemeProvider>
                    </LocationContextProvider>
                </OfferContextProvider>
            </ErrorContextProvider>
        </div>
        </ErrorBoundary>
    );
}

export default App;
